import revive_payload_client_4sVQNw7RlN from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/coingroup/fishcoin/market-client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/coingroup/fishcoin/market-client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_8SbxDRbG6Y from "/builds/coingroup/fishcoin/market-client/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import appear_6PGFcY9YPO from "/builds/coingroup/fishcoin/market-client/app-modules/core/plugins/appear.ts";
import eventBus_nd1hElHd7Y from "/builds/coingroup/fishcoin/market-client/app-modules/core/plugins/eventBus.ts";
import inputmask_IVcTr9JxjI from "/builds/coingroup/fishcoin/market-client/app-modules/core/plugins/inputmask.ts";
import userAgent_PG3hqDPLyN from "/builds/coingroup/fishcoin/market-client/app-modules/core/plugins/userAgent.ts";
import vuetify_IKzQjXDzcz from "/builds/coingroup/fishcoin/market-client/app-modules/core/plugins/vuetify.ts";
import _ioc_PuFj5NCJNH from "/builds/coingroup/fishcoin/market-client/app-modules/ioc/plugins/_ioc.ts";
import initIOCDependencies_heWAHUbJ8Y from "/builds/coingroup/fishcoin/market-client/app-modules/ioc/plugins/initIOCDependencies.ts";
import sentry_eqmXYqYY6I from "/builds/coingroup/fishcoin/market-client/app-modules/sentry/plugins/sentry.ts";
import vue_toastification_RHobUloYfk from "/builds/coingroup/fishcoin/market-client/app-modules/toasts/plugins/vue-toastification.ts";
import cookie_confirm_nuuL0zcJrb from "/builds/coingroup/fishcoin/market-client/app-modules/user-cookie-confirm/plugins/cookie-confirm.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_8SbxDRbG6Y,
  chunk_reload_client_UciE0i6zes,
  appear_6PGFcY9YPO,
  eventBus_nd1hElHd7Y,
  inputmask_IVcTr9JxjI,
  userAgent_PG3hqDPLyN,
  vuetify_IKzQjXDzcz,
  _ioc_PuFj5NCJNH,
  initIOCDependencies_heWAHUbJ8Y,
  sentry_eqmXYqYY6I,
  vue_toastification_RHobUloYfk,
  cookie_confirm_nuuL0zcJrb
]